<template>
	<section class="pool-create mt-3">
		<h1>Pool Create</h1>
		<div class="row">
			<div class="col-12 col-lg-6">
				<div class="card animate__animated animate__fadeIn h-100">
					<div class="card-header"></div>
					<div class="card-body pt-2">
						<DualSelect
							@update="onDualSelectUpdate"
							:b-enabled="true"
							:toggleSwap="false"
							@inputA="onInputA"
							@inputB="onInputB"
						></DualSelect>
					</div>
					<div class="card-footer mt-3">
						<button
							:disabled="loading"
							@click="createPool"
							class="btn btn-solid-primary w-100"
						>
							Create Pool
						</button>
					</div>
				</div>
			</div>
			<div class="col-12 col-lg-6 mt-3 mt-lg-0">
				<div class="card animate__animated animate__fadeIn h-100">
					<div class="card-header">
						<h4 class="mb-0">Pool</h4>
					</div>
					<div class="card-body">
						<table class="table table-sm table-borderless">
							<tbody>
								<tr>
									<td>Token A</td>
									<td>
										<AccountAddress
											:address="tokenA.address"
										></AccountAddress>
									</td>
								</tr>
								<tr>
									<td>Token B</td>
									<td>
										<AccountAddress
											:address="tokenB.address"
										></AccountAddress>
									</td>
								</tr>
								<tr>
									<td>Trade Fee</td>
									<td>
										{{
											config.tradeFee.numerator /
												config.tradeFee.denominator || 0
										}}
									</td>
								</tr>
								<tr>
									<td>Owner Trade Fee</td>
									<td>
										{{
											config.ownerTradeFee.numerator /
												config.ownerTradeFee
													.denominator || 0
										}}
									</td>
								</tr>
								<tr>
									<td>Owner Withdraw Fee</td>
									<td>
										{{
											config.ownerWithdrawFee.numerator /
												config.ownerWithdrawFee
													.denominator || 0
										}}
									</td>
								</tr>
								<!--							<tr>-->
								<!--								<td>Host Fee</td>-->
								<!--								<td>{{ config.hostFee.numerator / config.hostFee.denominator || 0 }}%</td>-->
								<!--							</tr>-->
								<tr>
									<td>Curve Type</td>
									<td>
										{{
											config.curveType
												? "Constant Product"
												: "Constant Price"
										}}
									</td>
								</tr>
								<tr>
									<td>Starting Price</td>
									<td>
										<span
											>1
											{{ tokenA?.symbol?.toUpperCase() }}
											≈
											{{
												(spotPrice || 0).toFixed(
													tokenB?.decimals
												)
											}}
											{{
												tokenB?.symbol?.toUpperCase()
											}}</span
										>
									</td>
								</tr>
							</tbody>
						</table>
						<Alert class="mb-3">
							LP Tokens are the allocation to your pool liquidity.
							Do not burn them.
						</Alert>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import { PoolFee, TokenInput } from "@/api/token_swap/layouts";
import { web3 } from "@project-serum/anchor";
import AccountAddress from "@/components/common/AccountAddress.vue";
import Alert from "@/components/common/Alert.vue";
import {
	HOST_FEE_DENOMINATOR,
	HOST_FEE_NUMERATOR,
	OWNER_TRADING_FEE_DENOMINATOR,
	OWNER_TRADING_FEE_NUMERATOR,
	OWNER_WITHDRAW_FEE_DENOMINATOR,
	OWNER_WITHDRAW_FEE_NUMERATOR,
	TRADING_FEE_DENOMINATOR,
	TRADING_FEE_NUMERATOR,
} from "@/api/token_swap/create_token_pool";
import SignatureLoader from "@/mixins/SignatureLoader";
import DualSelect from "@/components/token/DualSelect.vue";

export default {
	name: "PoolCreate",
	components: { DualSelect, AccountAddress, Alert },
	mixins: [SignatureLoader],
	data() {
		return {
			loading: false,
			config: {
				tradeFee: new PoolFee(
					TRADING_FEE_NUMERATOR,
					TRADING_FEE_DENOMINATOR
				),
				ownerTradeFee: new PoolFee(
					OWNER_TRADING_FEE_NUMERATOR,
					OWNER_TRADING_FEE_DENOMINATOR
				),
				ownerWithdrawFee: new PoolFee(
					OWNER_WITHDRAW_FEE_NUMERATOR,
					OWNER_WITHDRAW_FEE_DENOMINATOR
				),
				hostFee: new PoolFee(HOST_FEE_NUMERATOR, HOST_FEE_DENOMINATOR),
				curveType: 0,
			},
		};
	},
	computed: {
		tokenAAmount: function () {
			return this.$store.state.swap.tokenAAmount;
		},
		tokenBAmount: function () {
			return this.$store.state.swap.tokenBAmount;
		},
		tokenA: function () {
			return this.$store.state.swap.tokenA;
		},
		tokenB: function () {
			return this.$store.state.swap.tokenB;
		},

		spotPrice: function () {
			return this.tokenBAmount / this.tokenAAmount;
		},
	},
	methods: {
		onDualSelectUpdate: function () {
			console.log("onDualSelectUpdate");
		},
		onInputA: function () {
			console.log("onInputA");
		},
		onInputB: function () {
			console.log("onInputB");
		},

		// createPool: async function () {
		// 	const client = this.$store.state.solana.client //RPC Client
		//
		// 	const payer = new web3.PublicKey(this.$store.state.wallet.address)
		// 	const pkA = new web3.PublicKey(this.tokenA.address)
		// 	const pkB = new web3.PublicKey(this.tokenB.address)
		//
		// 	const resp = await fetch("https://api.fluxbeam.xyz/v1/token_pools", {
		// 		method: "POST",
		// 		headers: {
		// 			//@ts-ignore
		// 			"Content-Type": "application/json"
		// 		},
		// 		body: JSON.stringify({
		// 			payer: payer.toString(),
		// 			token_a: pkA,
		// 			token_a_amount: this.tokenAAmount,
		// 			token_b: pkB,
		// 			token_b_amount: this.tokenBAmount,
		// 			priority_fee_lamports: 10_000
		// 		}),
		// 	})
		// 	const j = await resp.json()
		//
		// 	const swapTransactionBuf = Buffer.from(j.transaction, 'base64');
		// 	const txn = VersionedTransaction.deserialize(swapTransactionBuf);
		//
		// 	//Wallet being a web3/Node wallet
		// 	const wallet = useWallet()
		// 	const signedTxn = await wallet.signTransaction(txn)
		//
		// 	const sig = await client.sendRawTransaction(signedTxn.serialize(), {signers: [], skipPreflight: true}).catch(e => {
		// 		console.error(`sendRawTransaction Transaction Failed`, e)
		// 	})
		// 	console.log("SIG", sig)
		// },

		createPool: async function () {
			const r = await this.$store.state.solana.swapClient.getSwapPools(
				new web3.PublicKey(this.tokenA.address),
				new web3.PublicKey(this.tokenB.address)
			);

			if (r && r.length > 0) {
				this.$toastr.e(
					"A pool already exists for given mints",
					"Pool already exists"
				);
				return;
			}

			const rInfo =
				await this.$store.state.solana.client.getMultipleParsedAccounts(
					[
						new web3.PublicKey(this.tokenA.address),
						new web3.PublicKey(this.tokenB.address),
					],
					{ commitment: "processed" }
				);

			const mintProgramA = rInfo.value[0]?.owner;
			const mintProgramB = rInfo.value[1]?.owner;

			const transactions =
				await this.$store.state.solana.swapClient.createPoolTransactions(
					new web3.PublicKey(this.$store.state.wallet.address),
					new web3.PublicKey(this.$store.state.wallet.address),
					new TokenInput(
						new web3.PublicKey(this.tokenA.address),
						this.tokenAAmount,
						mintProgramA
					),
					new TokenInput(
						new web3.PublicKey(this.tokenB.address),
						this.tokenBAmount,
						mintProgramB
					),
					this.config
				);

			this.loading = false;
			for (let i = 0; i < transactions.length; i++) {
				const sig = await this._sendTransaction(transactions[i]);
				if (!sig) break; //Failed
			}

			//Update our swap config
			localStorage.setItem(
				"swap:default_token_a",
				JSON.stringify(this.tokenA)
			);
			localStorage.setItem(
				"swap:default_token_b",
				JSON.stringify(this.tokenB)
			);
		},

		_sendTransaction: async function (transaction) {
			return await this.signAndSendTransaction(
				transaction.txn,
				"create_pool",
				transaction.signers,
				() => {
					this.loading = false;
				}
			);
		},

		tokenBalance: async function (token) {
			const resp =
				await this.$store.state.solana.tokenClient.getTokenBalance(
					new web3.PublicKey(token.address),
					new web3.PublicKey(this.$store.state.wallet.address),
					new web3.PublicKey(
						token.programID ||
							"TokenkegQfeZyiNwAJbNbGKPFXCWuBvf9Ss623VQ5DA"
					)
				);
			let amount =
				resp?.value?.data?.parsed?.info.tokenAmount.uiAmount || 0;

			if (
				token.address === "So11111111111111111111111111111111111111112"
			) {
				const solBal = await this.$store.state.solana.client.getBalance(
					new web3.PublicKey(this.$store.state.wallet.address),
					"confirmed"
				);
				console.log("SolBalance", solBal);
				amount += solBal / Math.pow(10, 9);
			}

			return amount;
		},
	},
	mounted() {
		this.tokenBalance(this.tokenA);
		this.tokenBalance(this.tokenB);
	},
};
</script>

<style scoped></style>
